// @flow
import React from 'react';
import styled from 'styled-components';
import * as Layout from 'styles/Layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const WrapperButton = styled(Layout.FlexRow)`
  height: 35px;
  align-items: center;
  &:hover span {
    text-decoration: underline;
  }
`;

const Text = styled.span`
  height: 35px;
  color: ${({ color = '#4a4a4a' }) => color};
  font-size: 14px;
  line-height: 35px;
  margin-left: 14px;
`;

type PropsType = {
  text: string,
  color?: string
};

export default class BackButtonComponent extends React.Component<PropsType> {
  render() {
    const { color } = this.props;

    return (
      <div>
        <WrapperButton>
          <FontAwesomeIcon
            icon="chevron-left"
            style={{ width: '12px', height: '19px' }}
          />
          <Text color={color}>{this.props.text}</Text>
        </WrapperButton>
      </div>
    );
  }
}
